/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useQuery, useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import Loader from 'components/common/Loader';
import { GET_ALL_TRADER_TAGS, ASSIGN_TRADER_TAG } from '../../VendorGraphQL';

const FlagCell = ({ initialColor = '', initialText = '', userId }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentColor, setCurrentColor] = useState(initialColor);
  const [currentText, setCurrentText] = useState(initialText);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const { data, loading: tagsLoading } = useQuery(GET_ALL_TRADER_TAGS, {
    fetchPolicy: 'cache-first',
  });

  const [assignTraderTag, { loading: assignLoading }] = useMutation(
    ASSIGN_TRADER_TAG,
    {
      onCompleted: () => {
        toast.success('Trader tag assigned successfully.');
      },
      onError: (err) => {
        toast.error(
          err?.graphQLErrors?.[0]?.message ||
            err?.message ||
            'Unable to assign trader tag.',
        );
      },
    },
  );

  useEffect(() => {
    setCurrentColor(initialColor);
    setCurrentText(initialText);
  }, [initialColor, initialText]);

  const handleSelectTag = async (tag) => {
    setCurrentColor(tag.colorCode);
    setCurrentText(tag.tagName);
    if (userId) {
      await assignTraderTag({
        variables: {
          userId: parseInt(userId, 10),
          traderTagId: parseInt(tag.id, 10),
        },
      });
    }
  };

  const tags = data?.getAllTraderTags?.filter((tag) => !tag.isDeleted) || [];

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
      <DropdownToggle
        tag="div"
        style={{ cursor: 'pointer', display: 'inline-block' }}
        disabled={assignLoading}
      >
        <div
          style={{
            width: '18px',
            height: '18px',
            backgroundColor: currentColor || 'transparent',
            borderRadius: '50%',
            cursor: assignLoading ? 'wait' : 'pointer',
            border: '1px solid #000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: currentColor ? '#fff' : '#000',
            fontSize: '10px',
            fontWeight: 'bold',
            textShadow: currentColor ? '0px 0px 2px #000' : 'none',
          }}
          title={currentText}
          aria-label="Vendor flag"
        />
      </DropdownToggle>
      <DropdownMenu>
        {tagsLoading && (
          <div className="p-2 text-center">
            <Loader size="sm" />
          </div>
        )}
        {!tagsLoading && tags.length > 0 && (
          tags.map((tag) => (
            <DropdownItem
              key={tag.id}
              onClick={() => handleSelectTag(tag)}
              className="d-flex align-items-center"
              style={{ gap: '8px' }}
            >
              <div
                style={{
                  width: '14px',
                  height: '14px',
                  backgroundColor: tag.colorCode,
                  borderRadius: '50%',
                  border: '1px solid #000',
                }}
              />
              <span style={{ fontFamily: 'inherit', fontSize: '13px' }}>
                {tag.tagName}
              </span>
            </DropdownItem>
          ))
        )}
        {!tagsLoading && tags.length === 0 && (
          <DropdownItem disabled>No tags available</DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default FlagCell;
